import React from "react"
import autobind from "class-autobind"
import { TextField } from "material-ui"
import { ITimecardEmployee, ELoggedInUserType, IUserDocument, IDate, IPayrollPayGroupData, IPayrollPayCalendar } from "../../../models"
import { grey500 } from "material-ui/styles/colors"
import AddUserDetailExpenseDialog from "../../../components/expense/AddUserDetailExpenseDialog"
import * as expenseActions from "../../../actions/ExpenseActions"
import * as userHelper from "../../../helpers/userHelper"

interface IProps {
    payDate: IDate
    user: ITimecardEmployee
    payrollDataForPayGroup: IPayrollPayGroupData | IPayrollPayCalendar
    loggedInUserType: ELoggedInUserType
    reloadTimecard(msg: string): void

    //to keep same logic as like add punch when add from component timecard
    hierarchyItemId: string
    jobId: string
    phaseId: string
    positionId: string
    payrollHierarchyId: string
    payrollPayGroupId: string
}
interface IState {
    openAddExpenseDialog: boolean
}

export default class EmployeeTimecardAddExpenseControl extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddExpenseDialog: false,
        }
        autobind(this)
    }

    render() {
        if (!userHelper.checkLoggedInUserPermission(this.props.user)) return null

        return (
            <div>
                <TextField
                    name="Single"
                    value="+ ADD"
                    hintText="+ ADD"
                    inputStyle={{ color: grey500 }}
                    style={{ width: "60px", fontSize: 12 }}
                    underlineStyle={{ borderColor: grey500 }}
                    onTouchTap={() => this.setState({ openAddExpenseDialog: true })}
                />
                {this.state.openAddExpenseDialog &&
                    <AddUserDetailExpenseDialog
                        loggedInUserType={this.props.loggedInUserType}
                        employee={this.props.user as IUserDocument}
                        payrollDataForPayGroup={this.props.payrollDataForPayGroup}
                        job={null}
                        payPeriodReferenceDate={this.props.payDate}
                        editExpense={null}
                        handleClose={() => this.setState({ openAddExpenseDialog: false })}
                        handleAdd={expenseBundle => expenseActions.addExpense(this.props.user, expenseBundle, this.props.reloadTimecard)}
                        handleUpdate={null}
                        showFrequencyControl={false}
                        frequency={0}
                        isOneTime={false}
                        payDate={this.props.payDate}
                        timecard
                        defaultAddHierarchyItemId={this.props.hierarchyItemId}
                        defaultAddJobId={this.props.jobId}
                        defaultAddPhaseId={this.props.phaseId}
                        defaultAddPositionId={this.props.positionId}
                        payrollHierarchyId={this.props.payrollHierarchyId}
                        payrollPayGroupId={this.props.payrollPayGroupId}
                    />
                }
            </div>
        )
    }
}
